import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <div className="mb-5 text-base flex flex-wrap items-center">
      <Link to="/" className="text-gray-500 hover:text-yellow-400">
        Home
      </Link>
      {items.map((item, index) => (
        <React.Fragment key={item.path}>
          <span className="mx-2 text-gray-500">&gt;</span>
          {index === items.length - 1 ? (
            <span className="text-yellow-400">{item.name}</span>
          ) : (
            <Link to={item.path} className="text-gray-500 hover:text-yellow-400">
              {item.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs; 